const mEditionBillingPaymentMethods = {
  mEditionBillingPaymentMethods: {
    action: 'Seleccionar',

    alerts: {
      updateAcademiaPasarelaEstado: {
        activationSuccess: 'El medio de pago fue activado exitosamente.',
        deactivationSuccess: 'El medio de pago fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    table: {
      thName: 'Descripción',
      thMethod: 'Medio',
      thActive: 'Activo',
      thEdit: 'Editar',
      thDelete: 'Eliminar'
    },

    title: {
      first: 'Selecciona el medio de pago con el que deseas vender tus productos en Vidroop',
      second: 'Medios de pago conectados a Vidroop'
    },

    tooltip: {
      data: 'Ver Datos',
      edit: 'Editar Medio',
      delete: 'Eliminar Medio'
    }
  }
}

export default mEditionBillingPaymentMethods
